import styled from "styled-components";

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  width: 30vw;
  height: 58vh;
  border: none !important;
  background: var(--black-200) !important;
`;

export const ModalOverlay = styled.div`
  background-color: rgba(25, 25, 25, 0.75) !important;
  inset: 0;
  width: 100vw;
  height: 100vh;
  position: fixed;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;

  ul {
    list-style-position: inside;

    li {
      margin-bottom: 0.4rem;
    }
  }

  p {
    color: var(--grey-100);

    margin-bottom: 1.2rem;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 1.5rem 2rem;
  border-right: 1px solid #3d3d3d;
  height:50vh;
  &:last-of-type {
    border-right: 0;
  }
`;

export const Title = styled.h2`
  font-family: "DM Sans", "Inter", sans-serif;
  margin-bottom: 2rem;
`;

export const FormTitle = styled.h4`
  margin-bottom: 1.3rem;
`;

export const FilterForm = styled.form`
  height:100%;
  display: flex;
  flex-direction: column;
  justify-content:space-between;
  div {
    margin-bottom: 20px;
  }

  input,
  button {
    width: 100%;
  }

  hr {
    margin-bottom: 1.5rem;

    height: 1px;
    background-color: #3d3d3d;
    border: none;
  }

  select {
    font-size: 1rem;
  }

  option {
    font-size: 0.8125rem;
  }
`;
